import {
  FETCH_INSIGHTS_SUMMARY,
  SET_INSIGHTS_SUMMARY,
  FETCH_INSIGHTS_FOOTFALL,
  SET_INSIGHTS_FOOTFALL,
  FETCH_INSIGHTS_FOOTFALL_OVER_TIME,
  SET_INSIGHTS_FOOTFALL_OVER_TIME,
  FETCH_INSIGHTS_FOOTFALL_PERCENTAGE,
  SET_INSIGHTS_FOOTFALL_PERCENTAGE,
  FETCH_INSIGHTS_REPEAT_VS_UNIQUE,
  SET_INSIGHTS_REPEAT_VS_UNIQUE,
  FETCH_DAILY_AVERAGES,
  SET_DAILY_AVERAGES,
  FETCH_INSIGHTS_POI_COUNT,
  SET_INSIGHTS_POI_COUNT,
  SELECT_INSIGHTS_TIME_PERIOD,
  DOWNLOAD_AUDIENCE,
  DOWNLOAD_AUDIENCE_SUCCESS,
  DOWNLOAD_AUDIENCE_FAILURE,
  LOG_OUT,
} from '../constants';

const initialState = {
  insightsSummaryLoaded: false,
  insightsSummaryData: {},
  insightsFootfallLoaded: false,
  insightsFootfallData: [],
  insightsDailyAveragesLoaded: false,
  insightsDailyAveragesData: {},
  insightsPoiCountLoaded: false,
  insightsPoiCountData: {},
  insightsFootfallOverTimeLoaded: false,
  insightsFootfallOverTimeData: [],
  insightsFootfallOverTimeDataUnit: 'day',
  insightsFootfallOverTimeDataRAW: [],
  insightsFootfallPercentageLoaded: false,
  insightsFootfallPercentageData: [],
  insightsFootfallRepeatLoaded: false,
  insightsFootfallRepeatData: {},
  downloadingCSV: false,
  csvType: null,
  selectedPeriod: {
    label: 'Last 90 days',
    value: 90
  },
};
/*
const combineFootfallOvertimeHours = data => {
  if (!Array.isArray(data)) {
    console.error('Expected array');
    return [];
  };
  const result = [];
  data.forEach(day => {
    const index = parseInt(day.timestamp.split('T')[1], 10);
    if (result[index] === undefined) {
      result[index] = {
        timestamp: `${index}:00`,
        value: day.value,
        baseline: day.baseline,
      };
    } else {
      result[index].value += day.value;
      result[index].baseline += day.baseline;
    }
  });
  return result;
}*/

const insights = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case FETCH_INSIGHTS_SUMMARY:
      return {
        ...state,
        insightsSummaryLoaded: false,
      };
    case SET_INSIGHTS_SUMMARY:
      return {
        ...state,
        insightsSummaryLoaded: true,
        insightsSummaryData: action.data,
      };
    case FETCH_INSIGHTS_FOOTFALL:
      return {
        ...state,
        insightsFootfallLoaded: false,
      };
    case SET_INSIGHTS_FOOTFALL:
      return {
        ...state,
        insightsFootfallLoaded: true,
        insightsFootfallData: action.data,
      };
    case FETCH_INSIGHTS_FOOTFALL_OVER_TIME:
      return {
        ...state,
        insightsFootfallOverTimeLoaded: false,
      };
    case SET_INSIGHTS_FOOTFALL_OVER_TIME:
      return {
        ...state,
        insightsFootfallOverTimeLoaded: true,
        insightsFootfallOverTimeData: action.data,
      };
    case FETCH_INSIGHTS_FOOTFALL_PERCENTAGE:
      return {
        ...state,
        insightsFootfallPercentageLoaded: false,
      };
    case SET_INSIGHTS_FOOTFALL_PERCENTAGE:
      return {
        ...state,
        insightsFootfallPercentageLoaded: true,
        insightsFootfallPercentageData: action.data,
      };
    case FETCH_INSIGHTS_REPEAT_VS_UNIQUE:
      return {
        ...state,
        insightsFootfallRepeatLoaded: false,
      };
    case SET_INSIGHTS_REPEAT_VS_UNIQUE:
      return {
        ...state,
        insightsFootfallRepeatLoaded: true,
        insightsFootfallRepeatData: action.data,
      };
    case FETCH_DAILY_AVERAGES:
      return {
        ...state,
        insightsDailyAveragesLoaded: false,
      };
    case SET_DAILY_AVERAGES:
      return {
        ...state,
        insightsDailyAveragesLoaded: true,
        insightsDailyAveragesData: action.data,
      };
    case DOWNLOAD_AUDIENCE:
      return {
        ...state,
        downloadingCSV: true,
        csvType: action.csvType,
      };
    case DOWNLOAD_AUDIENCE_SUCCESS:
      return {
        ...state,
        downloadingCSV: false,
      };
    case DOWNLOAD_AUDIENCE_FAILURE:
      return {
        ...state,
        downloadingCSV: false,
      };
    case SELECT_INSIGHTS_TIME_PERIOD:
      return {
        ...state,
        selectedPeriod: action.selectedPeriod,
      };
    case FETCH_INSIGHTS_POI_COUNT:
      return {
        ...state,
        insightsPoiCountLoaded: false,
      };
    case SET_INSIGHTS_POI_COUNT:
      return {
        ...state,
        insightsPoiCountLoaded: true,
        insightsPoiCountData: action.data,
      };

    default:
      return {
        ...state,
      };
  }
};

export default insights;
